<template>
  <div class="proposal-evaluation px-4">
    <div v-if="!readOnly">
      <proposal-evaluation-documents
        :proposal-request-id="Number(proposalRequestId)"
        title="Documentos de Propuesta"
      />
      <proposal-evaluation-documents
        v-if="amendmentDocument.length"
        :documents="amendmentDocument"
        title="Documentos de Enmienda"
      />
    </div>
    <proposal-evaluation-header
      v-if="evaluationSectionsSelecctionMultiple.length"
      :values="questionsHeader"
    />
    <div
      v-for="(section, indexSection) of evaluationSectionsSelecctionMultiple"
      :key="section.sectionId"
      class="proposal-evaluation__sections-list"
    >
      <div class="row d-flex justify-content-between align-items-center">
        <section-title
          :bg-icon="getBgIcon(isTypeVisible(section.sectionId))"
          class="col-12 col-md-6 proposal-evaluation__section-title mt-2 mb-2"
          container-class="proposal-evaluation__section-title__container"
          :icon="getIcon(isTypeVisible(section.sectionId))"
          :title="title(section)"
          title-class="m-0 proposal-evaluation__section-title__info"
          @on-click="toggleVisibility(section.sectionId)"
        />

        <div
          class="d-none d-md-block proposal-evaluation__section-title__container rounded-pill px-4"
          style="
             {
              width: '100px';
            }
          "
        >
          {{ filledQuestionsOf[indexSection] }}
        </div>
      </div>

      <transition name="list">
        <div v-show="isTypeVisible(section.sectionId)">
          <p class="proposal-evaluation__section-description">
            {{ section.subName }}
          </p>

          <div
            v-for="(question, indexQuestion) of section.questions"
            :key="question.questionId"
            class="mb-4"
          >
            <proposal-evaluation-question
              :question="question"
              :read-only="readOnly"
              @filled="
                (answer) =>
                  fillQuestion(indexSection, question, answer, indexQuestion)
              "
              @isTouched="emitTouched"
            />
          </div>
        </div>
      </transition>
    </div>
    <div v-if="evaluationSectionsLibre.length" class="bg-secondary-3 p-3">
      <span class="title">Complete</span>
      <p class="sub-title">Responda correctamente si aplica</p>
      <proposal-evaluation-complete
        v-for="question of evaluationSectionsLibre"
        :key="question.additionalQuestionId"
        class="mt-4 mb-3"
        :question="question"
        :read-only="readOnly"
        @filled="(answer) => fillQuestionComplete(question, answer)"
        @isTouched="emitTouched"
      />
    </div>
  </div>
</template>

<script>
import ProposalEvaluationQuestion from '@/views/provider/proposalHistory/components/ProposalEvaluationQuestion';
import ProposalEvaluationHeader from '@/views/provider/proposalHistory/components/ProposalEvaluationHeader';
import ProposalEvaluationDocuments from '@/views/provider/proposalHistory/components/ProposalEvaluationDocuments';
import SectionTitle from 'SectionTitle';
import alertMixin from 'utils/mixins/alert.mixin';
import ProposalEvaluationComplete from '@/views/provider/proposalHistory/components/ProposalEvaluationComplete.vue';
import { getAmendmentDocument } from '@/modules/serviceProposalHistory/api';

export default {
  name: 'ProposalEvaluation',
  components: {
    ProposalEvaluationQuestion,
    ProposalEvaluationHeader,
    SectionTitle,
    ProposalEvaluationComplete,
    ProposalEvaluationDocuments,
  },
  mixins: [alertMixin],
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    questionsHeader: [
      { name: 'Cumple', bgColor: '#A3E5B3' },
      { name: 'Cumple Parcial', bgColor: '#F8EB7F' },
      { name: 'No Cumple', bgColor: '#FAE7E7' },
    ],
    evaluationSectionsSelecctionMultiple: [],
    evaluationSectionsSelecctionMultipleVisibles: [],
    evaluationSectionsLibre: [],
    answers: [],
    filledAnswers: new Map(),
    filledAnswersComplete: new Map(),
    filledQuestionsOf: [],
    amendmentDocument: [],
  }),
  computed: {
    proposalRequestId() {
      return this.$route.params.proposalRequestId;
    },
    title() {
      return (section) =>
        (section.letter ? section.letter + '. ' : '') +
        section.sectionDescription;
    },
  },
  watch: {
    evaluation: {
      immediate: false,
      handler(current) {
        if (current && current.proposalEvaluationSections) {
          const evaluationSectionsSelecctionMultiple = [];
          const evaluationSectionsSelecctionMultipleVisibles = [];

          for (let section of current.proposalEvaluationSections) {
            var questions = section.questions.map((question) => {
              return {
                ...question,
                answerId: undefined,
              };
            });

            evaluationSectionsSelecctionMultiple.push({
              ...section,
              questions: questions,
            });
            evaluationSectionsSelecctionMultipleVisibles.push(
              section.sectionId
            );
          }

          this.evaluationSectionsSelecctionMultiple = [
            ...evaluationSectionsSelecctionMultiple,
          ];
          this.evaluationSectionsLibre = [
            ...current.proposalEvaluationAdditionalQuestionSections,
          ];
          this.evaluationSectionsSelecctionMultipleVisibles = [
            ...evaluationSectionsSelecctionMultipleVisibles,
          ];

          this.initFilledQuestionsOf();
        }
      },
    },
  },
  async mounted() {
    await this.getAmendmentDocument();
  },
  methods: {
    async getAmendmentDocument() {
      await getAmendmentDocument(this.proposalRequestId).then(({ data }) => {
        if (data?.documentId != null) {
          this.amendmentDocument.push({
            ...data,
            documentTypeName: 'Documento de Enmienda',
          });
        }
      });
    },
    toggleVisibility(id) {
      const visibles = [...this.evaluationSectionsSelecctionMultipleVisibles];
      const indexSelected = visibles.indexOf(id);

      if (indexSelected >= 0) {
        visibles.splice(indexSelected, 1);
      } else {
        visibles.push(id);
      }

      this.evaluationSectionsSelecctionMultipleVisibles = [...visibles];
    },
    isTypeVisible(id) {
      return this.evaluationSectionsSelecctionMultipleVisibles.includes(id);
    },
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    getBgIcon(expanded) {
      return expanded ? 'green' : 'gray';
    },
    initFilledQuestionsOf() {
      this.evaluationSectionsSelecctionMultiple.forEach((item, index) => {
        this.filledQuestions(index);
      });
    },
    fillQuestion(indexSection, question, answer, indexQuestion) {
      const answersSections = this.answers[indexSection]
        ? [...this.answers[indexSection]]
        : [];
      answersSections[indexQuestion] = {
        question,
        answer,
      };
      this.answers[indexSection] = [...answersSections];
      this.initFilledQuestionsOf();
      this.filledAnswers.set(question.questionId, {
        ...answer,
        isSelected: true,
      });
      this.$emit('updateAnswers', [...this.filledAnswers.values()]);
    },
    fillQuestionComplete(question, answer) {
      this.filledAnswersComplete.set(question.additionalQuestionId, {
        ...question,
        questionId: question.additionalQuestionId,
        answer,
      });

      this.$emit('updateAdditionalQuestions', [
        ...this.filledAnswersComplete.values(),
      ]);
    },
    filledQuestions(indexSection) {
      let amount = 0;
      if (this.answers[indexSection]) {
        const sectionAnswers = [...this.answers[indexSection]].filter((x) => x);
        amount = sectionAnswers.length;
      }

      this.$set(
        this.filledQuestionsOf,
        indexSection,
        `${amount} de ${this.evaluationSectionsSelecctionMultiple[indexSection].questions.length}`
      );
    },
    emitTouched() {
      this.$emit('isTouched', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.title {
  font-weight: bold;
  font-size: 1.125rem;
}
.sub-title {
  margin: 5px 0px 0px 5px;
}
.label {
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .label,
  .sub-title {
    font-size: 0.8571rem;
  }
  .title {
    font-size: 1rem;
  }
}

.proposal-evaluation {
  &__sections-list ::v-deep {
    .proposal-evaluation__section-title {
      cursor: pointer;

      &__container {
        background: map-get($colors, 'gray-9');
        display: flex;
        align-items: center;
        height: 50px;
        padding: 0.85rem 0.5rem;
        justify-content: flex-start;

        .title-icon {
          font-size: 12px;
        }

        .dot {
          width: 23px;
          height: 23px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      &__info {
        font-size: 0.8571rem;
        @media screen and (min-width: 768px) {
          font-size: 1.125rem;
        }
      }
    }
  }

  &__section-description {
    font-size: 0.875rem;
    color: map-get($colors, 'gray-6');
    margin-left: 25px;
  }
}
.list-enter-active,
.list-leave-active {
  transition: all 0.4s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
